import React, { PropTypes } from 'react';
import cx from 'classnames';

const buttonsClass = (mode, className) => cx(`ui buttons ${mode}`, className);

const buttonClass = canTouch =>
  cx('ui compact icon button', {
    disabled: !canTouch,
  });

const OrderButtons = ({
  canMoveDown,
  moveDown,
  canMoveUp,
  moveUp,
  mode = 'vertical',
  className = '',
}) => (
  <div className={buttonsClass(mode, className)}>
    <button className={buttonClass(canMoveUp)} onClick={moveUp}>
      <i className="chevron up icon" />
    </button>
    <button className={buttonClass(canMoveDown)} onClick={moveDown}>
      <i className="chevron down icon" />
    </button>
  </div>
);

OrderButtons.propTypes = {
  canMoveDown: PropTypes.bool.isRequired,
  moveDown: PropTypes.func.isRequired,
  canMoveUp: PropTypes.bool.isRequired,
  moveUp: PropTypes.func.isRequired,
  mode: PropTypes.string,
  className: PropTypes.string,
};

export default OrderButtons;



// WEBPACK FOOTER //
// ./src/modules/common/components/OrderButtons.js